(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/bubble-usp.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/bubble-usp.js');
"use strict";

const {
  useRef,
  useEffect,
  useState,
  useCallback
} = React;
const {
  cdn2
} = svs.core.config.data.svsconfig;
const {
  ANIMATIONS: {
    USP,
    USP_BACKGROUND
  }
} = svs.tickets.play.utils.constants;
const {
  getOptimalWidth
} = svs.utils;
setGlobal('svs.tickets.play.components.BubbleUsp', _ref => {
  let {
    appTimeline,
    ticketPitchImage,
    ticketPitchImageAvailableWidths,
    shouldPlayAnimation,
    onAnimationEnd,
    isFirstTime
  } = _ref;
  const optimalWidth = ticketPitchImageAvailableWidths ? getOptimalWidth(ticketPitchImageAvailableWidths, 320) : 320;
  const sized = cdn2 + ticketPitchImage.replace('{width}', optimalWidth);
  const uspTimeline = gsap.timeline();
  const bubbleRef = useRef(null);
  const imgRef = useRef(null);
  const [hasShownInitialUsp, setHasShownInitialPromo] = useState(false);
  const showUsp = useCallback(() => {
    const showTimeline = gsap.timeline();
    showTimeline.to(imgRef.current, USP.duration, {
      y: '-30%',
      ease: 'elastic.out(1, 0.4)'
    }, "showUsp+=".concat(USP.duration - USP_BACKGROUND.duration));
    showTimeline.to(bubbleRef.current, USP_BACKGROUND.duration, {
      background: 'rgba(0,0,0,0.5)',
      backdropFilter: 'blur(6px)',
      ease: 'linear',
      onStart: () => {
        bubbleRef.current && (bubbleRef.current.style.display = 'flex');
      }
    }, 'showUsp');
    return showTimeline;
  }, []);
  const hideUsp = useCallback(() => {
    const hideTimeline = new gsap.timeline();
    hideTimeline.to(imgRef.current, 1, {
      y: '-100%',
      ease: 'elastic.in(1.2, 0.75)'
    }, 'hideUsp');
    hideTimeline.to(bubbleRef.current, 0.6, {
      background: 'rgba(0,0,0,0)',
      backdropFilter: 'blur(0px)',
      ease: 'linear',
      onComplete: () => {
        bubbleRef.current && (bubbleRef.current.style.display = 'none');
        onAnimationEnd();
        setHasShownInitialPromo(true);
      }
    }, "hideUsp+=".concat(USP.duration - USP_BACKGROUND.duration));
    return hideTimeline;
  }, [onAnimationEnd]);
  useEffect(() => {
    if (isFirstTime) {
      appTimeline.add(showUsp(), 'showUsp');
      appTimeline.add(hideUsp(), 'hideUsp');
    } else {
      setHasShownInitialPromo(true);
    }
    return () => {
      uspTimeline.kill();
    };
  }, []);
  useEffect(() => {
    if (shouldPlayAnimation) {
      showUsp(0.4, true);
    }
  }, [shouldPlayAnimation, hasShownInitialUsp, hideUsp]);
  return React.createElement("div", {
    className: "bubble-usp-overlay",
    onClick: () => {
      if (hasShownInitialUsp) {
        hideUsp();
      } else {
        appTimeline.seek('hideUsp');
      }
    },
    ref: bubbleRef
  }, React.createElement("img", {
    className: "bubble-usp-image",
    ref: imgRef,
    src: sized
  }));
});

 })(window);